











































































































import { UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import BookmarkCard from "@/views/generic_components/BookmarkCard.vue"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"

@Component({ components: { BookmarkCard, H3TitleView, InputWithValidation } })
export default class ContactCardsView extends Vue {
  @Prop() contact: UtilisateurDTO

  displayedContact: UtilisateurDTO = new UtilisateurDTO()

  created(): void {
    this.setContact(this.contact)
  }

  @Watch("contact")
  setContact(newValue: UtilisateurDTO): void {
    if (!newValue.id) {
      this.setDefaultContact()
    } else {
      this.displayedContact = newValue
    }
  }

  setDefaultContact(): void {
    this.displayedContact.courriel = this.$t("default.email").toString()
    this.displayedContact.telephone = this.$t("default.phone").toString()
    this.displayedContact.nom = this.$t("default.profil").toString()
  }
}
